function propertyIdentity(property = {}) {
  const contentIdentity = [property.address, property.propertyName]
    .map(value => String(value || '').trim().toLocaleLowerCase())
    .join('|');
  if (contentIdentity !== '|') return `content:${contentIdentity}`;
  return `row:${property.rowIndex ?? ''}`;
}

export function buildCampaignDraftForbiddenValues({
  campaignLabel,
  campaignProperties = [],
  currentProperty,
  sendMode = 'separate',
  brokerProperties = [],
} = {}) {
  const allowedProperties = sendMode === 'combined' ? brokerProperties : [currentProperty];
  const allowedIdentities = new Set(allowedProperties.filter(Boolean).map(propertyIdentity));
  const forbidden = [campaignLabel];

  campaignProperties.forEach(property => {
    if (allowedIdentities.has(propertyIdentity(property))) return;
    forbidden.push(property.address, property.propertyName);
  });

  return [...new Set(forbidden.filter(value => typeof value === 'string' && value.trim().length > 0))];
}
